import store from '@/store'
import BasesStoreModule from '../bases/_store'

const TheTabs = () => import(/* webpackChunkName: "ConfigurationSystem" */ '../_components/TheTabsMain')

export const beforeEnter = (to, from, next = () => {}) => {
  if (!store.state.$_bases) {
    store.registerModule('$_bases', BasesStoreModule)
  }
  next()
}

export default [
  {
    path: 'alerting',
    name: 'alerting',
    component: TheTabs,
    props: () => ({ tab: 'alerting' }),
    beforeEnter
  }
]
